const formatMessage = (text: string, values: Record<string, string>) => {
  return Object.entries(values).reduce((ctx, [key, value]) => ctx.replace(`#{${key}}`, value), text);
};

export { formatMessage };
